<template>
  <div id="app">
    <Loader />
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loader from '@/components/Loader.vue'
// import fb from '@/firebase'
import store from '@/store'

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'successMessage',
      'errorMessage'
    ])
  },
  watch: {
    successMessage: {
      handler (val) {
        if (val) {
          this.$message.success(val, 2)
          store.dispatch('setSuccessMessage', null)
        }
      }
    },
    errorMessage: {
      handler (val) {
        if (val) {
          this.$message.error(val, 2)
          store.dispatch('setErrorMessage', null)
        }
      }
    }
  },
  components: {
    Loader
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue